import { IInformacionGeneral } from "../interfaces/InformacionGeneral";
import { get } from "./fetch";

export const getInformacionGeneralReps = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Info_Instrumentos OP:1 parametro o 2 sin
  var result = await get(`/api/info_general/representacion/${code}`);
  return result;
};

export const getInformacionGeneralProg = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Info_Instrumentos OP:3 parametro o 2 sin
  var result = await get(`/api/info_general/programa/${code}`);
  return result;
};

export const getInformacionGeneralRegional = async ():Promise<IInformacionGeneral> => {
  //Stored Procedure: DashboardSituacion_Get_Info_Instrumentos OP:4 Filtro_Unidad: IR
  var result = await get(`/api/info_general/regional`);
  return result;
}